import { Component } from '@angular/core';
import { SHARED_STANDALONE_IMPORTS } from 'app/shared/standalone-imports';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [...SHARED_STANDALONE_IMPORTS],
})
export class AppComponent {}
